import React, { useState, useEffect } from 'react';
import HeaderComponents from '../../components/HeaderComponents';
import { useDispatch, useSelector } from 'react-redux';
import { setEmployeeActiveButton } from '../../features/employeeSlice';
import { authFunction, roleAuth } from '../../utils/functionAuthorization';
import  EmployeeTemplate  from './EmployeeTemplate';
import "./../../utils/Style/pages/Employees.scss";
import NewEmployees from './NewEmployees';

function Employees() {
    const activeButton = useSelector(state => state.employees.employeeActiveButton);
    const dispatch = useDispatch();

    const accessPoints = {
        addEmployee: "ADD_EMPLOYEES",
        editEmployee: "EDIT_EMPLOYEES",
        changeEmployeeStatus: "CHANGE_EMPLOYEES_STATUS",
        deleteEmployee: "DELETE_EMPLOYEES",
        viewEmployee: "VIEW_EMPLOYEES"
    };

    const defaultActiveButton = roleAuth("employees") ? "Employees" : "";

    const [activeButtonLocal, setActiveButtonLocal] = useState({ name: defaultActiveButton });

    const handleButtonClick = (event) => {
        const newName = event.target.innerText;
        setActiveButtonLocal({ name: newName });
        dispatch(setEmployeeActiveButton({ name: newName}))
    };

    useEffect(() => {
        dispatch(setEmployeeActiveButton({ name: "Employees"}))
    }, [])

    return (
        <>
            <HeaderComponents title="Employees" />
            <div className='EmployeesPage'>
                <div className='container-fluid EmployeesContainer'>
                    <div className='row'>
                        <div className='col-lg-12 col-sm-12'>
                            <div className='top_section'>
                                {authFunction("employees", accessPoints.viewEmployee,
                                    <button 
                                        className={`navButton ${activeButton.name === "Employees" ? "active" : ""}`}
                                        onClick={handleButtonClick}>
                                        Employees
                                    </button>
                                )}
                                 {authFunction("employees", accessPoints.addEmployee,
                                    <button 
                                        className={`navButton ${activeButton.name === "+ New Employee" ? "active" : ""}`}
                                        onClick={handleButtonClick}>
                                        + New Employee
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-12"></div>
                    </div>
                    <div className='row'>
                        {activeButton.name === "Employees" && (
                            <EmployeeTemplate accessPoints={accessPoints} setActiveButton={setActiveButtonLocal} />
                        )}
                        {activeButton.name === "+ New Employee" && (
                            <NewEmployees accessPoints={accessPoints} setActiveButton={setActiveButtonLocal}/>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Employees;
